import mdi from "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import en from "vuetify/lib/locale/en";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa, en, mdi },
    current: "fa",
  },
  rtl: true,
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#007BFF",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#349bc7",
        success: "#72b34d",
        warning: "#edb022",
      },
      dark: {
        primary: "#007BFF",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#72b34d",
        warning: "#edb022",
      },
    },
    icons: {
      iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
  },
});
